<mat-menu #filtersMenu="matMenu">
  <ng-content select="filter-menu-items"></ng-content>
</mat-menu>

<div class="filter-chips">
  <ng-content select="va-filter-chip-container"></ng-content>
  <ng-content select="sales-ui-filter-chip"></ng-content>
  <button mat-button color="primary" [matMenuTriggerFor]="filtersMenu">
    + {{ 'FILTERS.CHIPS.FILTER' | translate }}
  </button>
  <ng-content select="filter-chip-actions"></ng-content>
</div>
